<div class="pt-20 ml-70 mr-70 mb-60">
  <div class="flex flex-row items-center" *ngIf="showJumpBox || showSchedule">
    <div class="mat-headline-5 pl-12">Dashboard</div>
    <div class="jumpbox-align" *ngIf="showJumpBox">
      <app-jumpbox-message pageName="jumpbox" (showToast)="handleJumpboxNotification($event)"></app-jumpbox-message>
    </div>
    <div class="jumpbox-align" *ngIf="showSchedule">
      <app-jumpbox-message pageName="schedule" (showToast)="handleScheduleNotification($event)"></app-jumpbox-message>
    </div>
  </div>
  <div class="flex gap-8">
    <div class="tile-schedule">
      <div class="card-container flex-col mt-12 p-20" [ngClass]="showJumpBox ? 'pt-20': null ">
        <div class="title">
          {{'TENANT_DASHBOARD.INSTANCES_COUNT' | transloco}}
        </div>
        <div class="flex card-section pt-16">
          <ng-container *ngFor="let tile of insightTiles">
            <div class="card p-24">
              <div class="flex justify-between items-center">
                <div class="flex flex-row items-center">
                  <div class="pr-12">
                    <span *ngIf="tile.key === 'total'" class="icon-section building flex items-center justify-center"><img src="/assets/images/building.svg" /></span>
                    <span *ngIf="tile.key === DeployStatus.DEPLOYED" class="icon-section layers flex items-center justify-center"><img src="/assets/images/layers.svg" /></span>
                    <span *ngIf="tile.key === DeployStatus.DEPLOYING && tile.count > 0" class="loading-section flex items-center justify-center"><img class="loading-icon" src="/assets/images/refreshLoader.gif" /></span>
                    <span *ngIf="tile.key === DeployStatus.DEPLOYING && tile.count === 0" class="loading-section flex items-center justify-center"><img class="loading-icon" src="/assets/images/refreshIcon.svg" /></span>
                  </div>
                  <div class="fw-400 fs-20">{{tile.title | transloco}}</div>
                </div>
                <div class="flex flex-row">
                  <div *ngIf="tile.loading && instancePermission" class="skeleton mb-4"></div>
                  <div *ngIf="!tile.loading && instancePermission" class="mat-body-1 fs-40 fw-500 mb-4">{{ tile.count }}</div>
                  <div *ngIf="!instancePermission" class="mb-4">
                    <mat-icon svgIcon="warning_amber" class="h-32 w-32 warning"></mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      @if (!isExternalTenant) {
      <div class="p-20 schedule-section mt-20">
        <div class="mb-16 pr-8 flex justify-between items-center">
          <div>
            <div class="title">{{'SCHEDULES.FOUNDATION_SCHEDULE' | transloco}}</div>
          </div>
          <div>
            <mat-select class="fw-500 form-sel fs-16 schedule-dropdown" placeholder="{{'TENANT_DASHBOARD.YEAR' | transloco}}" panelClass="schedule-dropdown" [(value)]="selectedYr" (selectionChange)="selectionChanged('year', $event.value)">
              @for (year of years; let i = $index; track year) {
                <mat-option [value]="year">{{ year }}</mat-option>
                @if (i < years.length - 1) {
                  <mat-divider class="neutral-2 mb-4"></mat-divider>
                }
              }
            </mat-select>
            <mat-select class="fw-500 form-sel fs-16 schedule-dropdown ml-16" placeholder="{{'TENANT_DASHBOARD.MONTH' | transloco}}" panelClass="schedule-dropdown" [(value)]="selectedMonth" (selectionChange)="selectionChanged('month', $event.value)">
              @for (month of months; let i = $index; track month) {
                <mat-option [value]="month">{{ month }}</mat-option>
                @if (i < months.length - 1) {
                  <mat-divider class="neutral-2 mb-4"></mat-divider>
                }
              }
            </mat-select>
            <mat-select class="fw-500 form-sel fs-16 schedule-dropdown ml-16" placeholder="{{'TENANT_DASHBOARD.WEEK' | transloco}}" panelClass="schedule-dropdown" [(value)]="selectedWeek" (selectionChange)="selectionChanged('week', $event.value)">
              @for (week of weeks; let i = $index; track week) {
                <mat-option [value]="week">{{ week }}</mat-option>
                @if (i < weeks.length - 1) {
                  <mat-divider class="neutral-2 mb-4"></mat-divider>
                }
              }
            </mat-select>
          </div>
        </div>
        <div class="schedule-calendar">
          <mwl-calendar-week-view
            [daysInWeek]="7"
            [viewDate]="viewDate"
            [events]="events"
            [hourSegments]="1"
            (eventClicked)="handleEvent($event.event)"
          ></mwl-calendar-week-view>
        </div>
      </div>
      }
      @if (isExternalTenant) {
      <div class="p-20 schedule-section mt-20">
        <ng-container *ngTemplateOutlet="instancesByServiceDefTemplate"></ng-container>
      </div>
      }
    </div>
    <div class="left-section-width-50 p-20 mt-12">
      <div class="title">
        {{'TENANT_DASHBOARD.RECENT_ACTIVITY' | transloco}}
      </div>
      <div *ngIf="isInstanceLoaded && recentActivityInstances?.length > 0" class="dashboard-table mt-24 recent-activity">
        <ng-container>
          <table mat-table [dataSource]="recentActivityInstances" class="w-100-percent recent-activity">
            <ng-container matColumnDef="instance">
              <th mat-header-cell class="fs-18 fw-500" *matHeaderCellDef>{{'TENANT_DASHBOARD.INSTANCE' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> <span class="cursor-pointer underline fw-400" (click)="instanceNameClick(element)">{{element?.name}}</span> </td>
            </ng-container>
            <ng-container matColumnDef="activity">
              <th mat-header-cell class="fs-18 fw-500 left-width" *matHeaderCellDef>{{'TENANT_DASHBOARD.ACTIVITY' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="flex items-center">
                  <div class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? DeployStatus.ABORTING : element?.status">
                    <span>
                      <mat-icon svgIcon="change_circle" class="icon-md p-2 mr-6" [ngClass]="element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? DeployStatus.ABORTING : element?.status"></mat-icon>
                    </span>
                    <span class="fs-16">{{(element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? element?.lastOperation?.executionPhase + ' ' + element?.lastOperation?.type : element?.status) | titlecase}}</span>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="recentActivityColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: recentActivityColumns;"></tr>
          </table>
        </ng-container>
      </div>
      <div *ngIf="isInstanceLoaded && recentActivityInstances?.length === 0" class="empty-data flex flex-col items-center justify-center pb-120 mt-16">
        <img class="w-106" src="/assets/images/no_data_found.png">
        <div class="flex mt-6">{{'TENANT_DASHBOARD.NO_RECENT_ACTIVITY' | transloco }}</div>
      </div>
      <div *ngIf="!isInstanceLoaded" class="loader-section mt-24">
        <div class="instances-group loader-header flex flex-col p-16">
          <div class="flex flex-row justify-between">
            <ng-container *ngFor="let item of [1,2]">
              <div class="loader-style">
                <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngFor="let item of [1,2,3,4,5,6]" class="w-100-percent">
          <div class="instances-group flex flex-col p-16">
              <div class="flex flex-row justify-between">
                <ng-container *ngFor="let item of [1,2]">
                  <div class="loader-style">
                    <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (!isExternalTenant) {
  <div class="flex flex-row gap-8 pt-20">
    <div class="p-20 left-section-width-50">
      <ng-container *ngTemplateOutlet="instancesByServiceDefTemplate"></ng-container>
    </div>
    @if (azureCobEnabled || isAWS) {
      <div class="p-20 cob left-section-width-50">
        <div class="flex flex-row pb-8">
          <span class="title">{{'TENANT_DASHBOARD.COB_SCHEDULE' | transloco}}</span>
        </div>
        <div *ngIf="permissionsMap[PermissionKeys.BLUEPRINT_READ]" class="w-100-percent">
        <div class="mat-body fw-500 pt-8 blueprints-dropdown" [ngClass]="{'not-selected': !selectedCobBlueprint}">
          <mat-form-field appearance="outline">
            <mat-label class="service-def" (click)="labelClick()">{{'TENANT_DASHBOARD.CHOOSE_SERVICE_DEFINITION' | transloco }}</mat-label>
            <mat-select class="form-select" [(value)]="selectedCobBlueprint" panelClass="blueprint-dropdown" (selectionChange)="blueprintCobChanged($event.value)">
              @for (blueprint of blueprints; let i = $index; track blueprint) {
                <mat-option [value]="blueprint">{{ blueprint.name }}</mat-option>
                @if (i < blueprints.length - 1) {
                  <mat-divider class="neutral-2 mb-4"></mat-divider>
                }
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="dashboard-table ser-def-table">
        <ng-container *ngIf="isCobInsSelectionLoaded && instanceByCobServiceDefinition?.filteredData?.length > 0">
          <table mat-table [dataSource]="instanceByCobServiceDefinition" class="w-100-percent">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{'TENANT_DASHBOARD.INSTANCE' | transloco}}</th>
              <td mat-cell *matCellDef="let element" class="name cursor-pointer" (click)="openInstanceDetails(element)"><div>{{element?.name}}</div></td>
            </ng-container>
            <ng-container matColumnDef="schedule">
              <th mat-header-cell *matHeaderCellDef>{{'TENANT_DASHBOARD.COB_SCHEDULE' | transloco}}</th>
              <td mat-cell *matCellDef="let element" class="version">
                <mat-icon svgIcon="work_history" [satPopoverAnchor]="p"
                (mouseenter)="p.open()"
                (mouseleave)="p.close()" [matTooltipHideDelay]="1000000" matTooltipClass="above" matTooltipPosition="above" class="info-icon" [ngClass]="element?.cob?.inputs ? 'cursor-pointer' : 'disabled cursor-default'"></mat-icon>
                <sat-popover #p verticalAlign="above">
                  <div class="tooltip-wrapper">
                    <span>{{'TEST_RESULTS.SCHEDULE1' | transloco | titlecase}}: {{(sch1 ? sch1 : '-')}}<br>{{'TEST_RESULTS.SCHEDULE2' | transloco | titlecase}}: {{(sch2 ? sch2 : '-')}}<br>{{'TEST_RESULTS.TIMEZONE' | transloco | titlecase}}: {{(timeZone ? timeZone : '-')}}</span>
                  </div>
                </sat-popover>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{'TENANT_DASHBOARD.STATUS' | transloco}}</th>
              <td mat-cell *matCellDef="let element">
                <div class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? DeployStatus.ABORTING : element?.status">
                  <span>
                    <mat-icon *ngIf="completedStatus.includes(element?.status)" [svgIcon]="element?.status === 'deployed' ? 'check_circle_filled' : 'check_circle'" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                    <mat-icon *ngIf="terminateStatus.includes(element?.status)" svgIcon="error_outline" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                    <mat-icon *ngIf="errorStatus.includes(element?.status)" svgIcon="cancel_filled" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                    <mat-icon *ngIf="inprogressStatus.includes(element?.status) || element?.lastOperation?.executionPhase === DeployStatus.ABORTING" svgIcon="change_circle" class="icon-md p-2 mr-6" [ngClass]="element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? DeployStatus.ABORTING : element?.status"></mat-icon>
                  </span>
                  <span class="fw-400">{{(element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? element?.lastOperation?.executionPhase + ' ' + element?.lastOperation?.type : element?.status) | titlecase}}</span>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="instanceByCobColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: instanceByCobColumns;"></tr>
          </table>
        </ng-container>
        <ng-container *ngIf="isCobInsSelectionLoaded && instances?.length === 0 && instancePermission">
          <div class="dashboard-table ser-def-table w-100-percent flex items-center justify-center pt-32 pb-40 flex-col">
            <img src="/assets/images/no-data.png" alt="No data found" class="w-106" />
            <span class="select-text">{{'TENANT_DASHBOARD.NO_INSTANCES' | transloco}}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="!isCobInsSelectionLoaded && instancePermission">
          <div class="loader-section">
            <div class="instances-group loader-header flex flex-col p-16">
              <div class="flex flex-row">
                <ng-container *ngFor="let item of [1,2,3]">
                  <div class="loader-style">
                    <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </div>
            </div>
            <div *ngFor="let item of [1,2,3]" class="w-100-percent">
              <div class="instances-group flex flex-col p-16">
                  <div class="flex flex-row">
                    <ng-container *ngFor="let item of [1,2,3]">
                      <div class="loader-style">
                        <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
                      </div>
                    </ng-container>
                  </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!instancePermission">
          <div class="flex flex-col items-center pt-30 unauth-container pb-90">
            <mat-icon svgIcon="warning_amber" class="w-44 h-44 warning"></mat-icon>
            <div class="fw-600 fs-20 mat-subtitle-2 mt-16"> {{ 'UNAUTHORIZED.SECTION_MESSAGE' | transloco }}</div>
          </div>
        </ng-container>
      </div>
    </div>
  }
  </div>
  }
  <div class="flex flex-row gap-8 pt-20">
    <div class="p-20 left-section">
      <div class="flex flex-row pb-8">
        <span class="title">{{'TENANT_DASHBOARD.INSTANCES_COUNT_BY_ENVT_CLASS' | transloco}}</span>
      </div>
      <div *ngIf="permissionsMap[PermissionKeys.BLUEPRINT_READ]" class="w-100-percent">
        <div class="mat-body fw-500 pt-8 blueprints-dropdown" [ngClass]="{'not-selected': !selectedBlueprintForClass}">
          <mat-form-field appearance="outline">
            <mat-label class="service-def" (click)="labelClick()">{{'TENANT_DASHBOARD.CHOOSE_SERVICE_DEFINITION' | transloco }}</mat-label>
            <mat-select class="form-select" placeholder="{{'TENANT_DASHBOARD.CHOOSE_SERVICE_DEFINITION' | transloco}}" [(value)]="selectedBlueprintForClass" panelClass="blueprint-dropdown" (selectionChange)="blueprintChangedForClass($event.value)">
              @for (blueprint of blueprints; let i = $index; track blueprint) {
                <mat-option [value]="blueprint">{{ blueprint.name }}</mat-option>
                @if (i < blueprints.length - 1) {
                  <mat-divider class="neutral-2 mb-4"></mat-divider>
                }
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="dashboard-table class-table">
        <ng-container *ngIf="isInsClassLoaded && instancePermission">
          <table mat-table [dataSource]="instanceByClass" class="w-100-percent">
            <ng-container matColumnDef="name">
              <th mat-header-cell class="fs-14" *matHeaderCellDef>{{'TENANT_DASHBOARD.CLASS' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
            </ng-container>
            <ng-container matColumnDef="value">
              <th mat-header-cell class="fs-14 left-width" *matHeaderCellDef>{{'TENANT_DASHBOARD.COUNT' | transloco}}</th>
              <td mat-cell *matCellDef="let element"> {{element?.value}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="datazoneColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: datazoneColumns;"></tr>
          </table>
        </ng-container>
        <ng-container *ngIf="!isInsClassLoaded && instancePermission">
          <div class="loader-section">
            <div class="instances-group loader-header flex flex-col p-16">
              <div class="flex flex-row justify-between">
                <ng-container *ngFor="let item of [1,2]">
                  <ngx-skeleton-loader class="loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
                </ng-container>
              </div>
            </div>
            <div *ngFor="let item of [1,2,3]" class="w-100-percent">
              <div class="instances-group flex flex-col p-16">
                  <div class="flex flex-row justify-between">
                    <ng-container *ngFor="let item of [1,2]">
                      <ngx-skeleton-loader class="loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
                    </ng-container>
                  </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!instancePermission">
          <div class="flex flex-col items-center pt-80 unauth-container pb-50">
            <mat-icon svgIcon="warning_amber" class="w-44 h-44 warning"></mat-icon>
            <div class="fw-600 fs-20 mat-subtitle-2 mt-16"> {{ 'UNAUTHORIZED.SECTION_MESSAGE' | transloco }}</div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="p-20 right-section">
      <div class="flex flex-row pb-8">
        <span class="fw-600">{{'TENANT_DASHBOARD.NUMBER_OF_INSTANCES_BY_STATUS' | transloco}}</span>
      </div>
      <div *ngIf="isInstanceLoaded && instanceDetails?.length !== 0" echarts [options]="instanceBySolutionPiechart" class="chart-dimension instance-chart pr-70 pt-20"></div>
      <div *ngIf="isInstanceLoaded && instanceDetails?.length === 0 && instancePermission" class="flex justify-center items-center p-20 chart-dimension flex-col">
        <img src="/assets/images/no-data.png" alt="No data found" class="w-106" />
        <div class="select-text">{{'TENANT_DASHBOARD.NO_INSTANCES' | transloco }}</div>
      </div>
      <div *ngIf="!isInstanceLoaded && instancePermission">
        <div class="chart-dimension flex items-center justify-center">
          <mat-spinner class="flex items-center justify-center" diameter="24"
            color="primary"
            mode="indeterminate">
          </mat-spinner>
        </div>
      </div>
      <ng-container *ngIf="!instancePermission">
        <div class="flex flex-col items-center unauth-container pb-50" [ngClass]="[permissionsMap[PermissionKeys.BLUEPRINT_READ] ? 'pt-160': ' pt-80']">
          <mat-icon svgIcon="warning_amber" class="w-44 h-44 warning"></mat-icon>
          <div class="fw-600 fs-20 mat-subtitle-2 mt-16"> {{ 'UNAUTHORIZED.SECTION_MESSAGE' | transloco }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #instancesByServiceDefTemplate>
  <div class="flex flex-row pb-8">
    <span class="title">{{'TENANT_DASHBOARD.INSTANCES_BY_SERVICE_DEFINITION' | transloco}}</span>
  </div>
  <div *ngIf="permissionsMap[PermissionKeys.BLUEPRINT_READ]" class="w-100-percent">
    <div class="mat-body fw-500 pt-8 blueprints-dropdown" [ngClass]="{'not-selected': !selectedBlueprint}">
      <mat-form-field appearance="outline">
        <mat-label class="service-def" (click)="labelClick()">{{'TENANT_DASHBOARD.CHOOSE_SERVICE_DEFINITION' | transloco }}</mat-label>
        <mat-select class="form-select" [(value)]="selectedBlueprint" panelClass="blueprint-dropdown" (selectionChange)="blueprintChanged($event.value)">
          @for (blueprint of blueprints; let i = $index; track blueprint) {
            <mat-option [value]="blueprint">{{ blueprint.name }}</mat-option>
            @if (i < blueprints.length - 1) {
              <mat-divider class="neutral-2 mb-4"></mat-divider>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="dashboard-table ser-def-table">
    <ng-container *ngIf="isInsSelectionLoaded && instanceByServiceDefinition?.filteredData?.length > 0">
      <table mat-table [dataSource]="instanceByServiceDefinition" class="w-100-percent">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{'TENANT_DASHBOARD.INSTANCE' | transloco}}</th>
          <td mat-cell *matCellDef="let element" class="name cursor-pointer" (click)="openInstanceDetails(element)"><div>{{element?.name}}</div></td>
        </ng-container>
        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef>{{'TENANT_DASHBOARD.CURRENT_VERSION' | transloco}}</th>
          <td mat-cell *matCellDef="let element" class="version">
            <div class="flex items-center">
              {{element?.releaseVersion ? element?.releaseVersion : '-'}}
              <span *ngIf="solutionVersionsService.releaseVersion(instance?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
                {{('INSTANCE_DETAILS.AMR' | transloco)}}
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{'TENANT_DASHBOARD.STATUS' | transloco}}</th>
          <td mat-cell *matCellDef="let element">
            <div class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? DeployStatus.ABORTING : element?.status">
              <span>
                <mat-icon *ngIf="completedStatus.includes(element?.status)" [svgIcon]="element?.status === 'deployed' ?  'check_circle_filled' : 'check_circle'" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                <mat-icon *ngIf="terminateStatus.includes(element?.status)" svgIcon="error_outline" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                <mat-icon *ngIf="errorStatus.includes(element?.status)" svgIcon="cancel_filled" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                <mat-icon *ngIf="inprogressStatus.includes(element?.status) || element?.lastOperation?.executionPhase === DeployStatus.ABORTING" svgIcon="change_circle" class="icon-md p-2 mr-6" [ngClass]="element?.lastOperation?.executionPhase === DeployStatus.ABORTING? DeployStatus.ABORTING : element?.status"></mat-icon>
              </span>
              <span class="fw-400">{{(element?.lastOperation?.executionPhase === DeployStatus.ABORTING ? element?.lastOperation?.executionPhase + ' ' + element?.lastOperation?.type : element?.status) | titlecase}}</span>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="instanceBySerDefColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: instanceBySerDefColumns;"></tr>
      </table>
    </ng-container>
    <ng-container *ngIf="isInsSelectionLoaded && instances?.length === 0 && instancePermission">
      <div class="dashboard-table ser-def-table w-100-percent flex items-center justify-center pt-32 pb-40 flex-col">
        <img src="/assets/images/no-data.png" alt="No data found" class="w-106" />
        <span class="select-text">{{'TENANT_DASHBOARD.NO_INSTANCES' | transloco}}</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!isInsSelectionLoaded && instancePermission">
      <div class="loader-section">
        <div class="instances-group loader-header flex flex-col p-16">
          <div class="flex flex-row">
            <ng-container *ngFor="let item of [1,2,3]">
              <div class="loader-style">
                <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngFor="let item of [1,2,3]" class="w-100-percent">
          <div class="instances-group flex flex-col p-16">
            <div class="flex flex-row">
              <ng-container *ngFor="let item of [1,2,3]">
                <div class="loader-style">
                  <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!instancePermission">
      <div class="flex flex-col items-center pt-30 unauth-container pb-90">
        <mat-icon svgIcon="warning_amber" class="w-44 h-44 warning"></mat-icon>
        <div class="fw-600 fs-20 mat-subtitle-2 mt-16"> {{ 'UNAUTHORIZED.SECTION_MESSAGE' | transloco }}</div>
      </div>
    </ng-container>
  </div>
</ng-template>
